import { render, staticRenderFns } from "./GanttChartV3.vue?vue&type=template&id=83774a7c&scoped=true&"
import script from "./GanttChartV3.vue?vue&type=script&lang=js&"
export * from "./GanttChartV3.vue?vue&type=script&lang=js&"
import style0 from "./GanttChartV3.vue?vue&type=style&index=0&id=83774a7c&lang=scss&scoped=true&"
import style1 from "./GanttChartV3.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83774a7c",
  null
  
)

export default component.exports